/**
 * Bot/Crawler detection based on User-Agent string.
 * Runtime: Edge/Node — no browser or Node-specific APIs used.
 */
import { isbot } from 'isbot';

/**
 * Check if a User-Agent string belongs to a bot/crawler.
 */
export function isBotUA(ua: string): boolean {
  if (!ua) return false;
  return isbot(ua);
}
